import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Usuario } from 'src/app/workflow/tab-profiles/users.interface';
import { enviroment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserRequestService {
  constructor(private httpClient: HttpClient) {}

  async getUsers(): Promise<Usuario[]> {
    const response = await firstValueFrom<Usuario[]>(
      this.httpClient.get<Usuario[]>(enviroment.url + 'usuario'),
    );
    return response;
  }

  async postUser(payload: any): Promise<any> {
    return firstValueFrom<any>(
      this.httpClient.post<any>(enviroment.url + 'usuario', payload),
    );
  }

  async post_employee_saldo(objeto:any): Promise<any> {
    return firstValueFrom<any>(
      this.httpClient.post<any>(enviroment.url + 'usuario/saldo', objeto),
    );
  }
}
